import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import Modal from 'components/Modal'
import { makeDefaultFailedContainer } from 'components/container'
import Button from 'shared-web/src/components/Button'
import style from './style.styl'

class GlobalModal extends Component {
  static propTypes = {
    modalState: ImmutablePropTypes.recordOf({
      show: PropTypes.bool.isRequired,
      data: ImmutablePropTypes.recordOf({
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        confirm: PropTypes.string.isRequired,
        onConfirm: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
      }).isRequired,
    }).isRequired,
  }

  render() {
    const {
      show,
      data: { title, description, confirm, onConfirm, onCancel, buttonProps },
    } = this.props.modalState

    if (show) {
      return (
        <Modal
          onClose={onCancel}
          modalContentClassName={`${style.GlobalModal} flex-column flex-center`}
        >
          <div className={`${style.GlobalModalContent} flex-column flex-space-around flex-1`}>
            <h3 className="dsg-h3">
              {title}
            </h3>
            <div className="color-gray-dark">
              {description}
            </div>
          </div>
          <div className={`${style.GlobalModalButtonContainer} flex-center`}>
            <Button onClick={onConfirm} size="medium" cta {...buttonProps}>
              {confirm}
            </Button>
          </div>
        </Modal>
      )
    } else {
      return <div />
    }
  }
}

const GlobalModalContainer = makeDefaultFailedContainer(GlobalModal, {
  listenTo: ['stores.GlobalModalStore'],
  fetch: {
    modalState() {
      return this.app.stores.GlobalModalStore.getModalState()
    },
  },
})

export default GlobalModalContainer



// WEBPACK FOOTER //
// ./src/scripts/components/GlobalModal/index.js